import { useFormik } from 'formik';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  Row
} from 'reactstrap';
import { InputField } from 'src/components';
import { setFromErrors } from 'src/helpers';
import { useCreateProgressReportInterviewAssesmentMutation } from 'src/rtk/features/logbookMonitoringReport/logbookMonitoringReportApi';
import loader from '../../assets/images/loader.gif';

interface AssesmentFields {
  interview_id?: string;
  participant_id?: string;
  // Recent Seen Case (Cold)
  point_in_history?: string;
  point_in_history_assessment?: number;
  point_in_examination?: string;
  point_in_examination_assessment?: number;
  recently_seen_case_comment?: string;

  // Emergency Managed
  problem?: string;
  problem_assessment?: number;
  how_managed?: string;
  how_managed_assessment?: number;
  emergency_managed_comment?: string;

  // Procedure
  why_done?: string;
  why_done_assessment?: number;
  how_done?: string;
  how_done_assessment?: number;
  procedure_comment?: string;
}

const ProgressReportInterview = (props: any) => {
  const { isOpen, toggle, traineeData } = props;

  const [createProgressReportInterviewAssesment, { isSuccess, isLoading, isError, error }] = useCreateProgressReportInterviewAssesmentMutation();
  console.log(traineeData)
  const err: CustomError = error as CustomError;

  const evaluationOptions = [
    { value: 1, label: 'Poor' },
    { value: 2, label: 'Good' },
    { value: 3, label: 'Excellent' },
  ];

  const initialValues: AssesmentFields = {
    interview_id: '',
    participant_id: '',
    // Recent Seen Case (Cold)
    point_in_history: '',
    point_in_history_assessment: 0,
    point_in_examination: '',
    point_in_examination_assessment: 0,
    recently_seen_case_comment: '',

    // Emergency Managed
    problem: '',
    problem_assessment: 0,
    how_managed: '',
    how_managed_assessment: 0,
    emergency_managed_comment: '',

    // Procedure
    why_done: '',
    why_done_assessment: 0,
    how_done: '',
    how_done_assessment: 0,
    procedure_comment: '',
  };


  const formik = useFormik({
    initialValues,

    onSubmit: (values) => {
      const submittedValues = {
        ...values,
        point_in_history_assessment: Number(values.point_in_history_assessment),
        point_in_examination_assessment: Number(values.point_in_examination_assessment),
        problem_assessment: Number(values.problem_assessment),
        how_managed_assessment: Number(values.how_managed_assessment),
        why_done_assessment: Number(values.why_done_assessment),
        how_done_assessment: Number(values.how_done_assessment),
        interview_id: traineeData?.interview_id,
        participant_id: traineeData?.id,
      };
      console.log(submittedValues);
      createProgressReportInterviewAssesment(submittedValues);
    },
  });

  const {
    handleSubmit,
    getFieldProps,
    handleChange,
    values,
    touched,
    errors,
    resetForm,
    setErrors,
  } = formik;


  useEffect(() => {
    if (isSuccess) {
      toast.success('Interview Schedule Created Successfully');
      resetForm();
      toggle();
    }
    if (isError) {
      toast.error(err?.message || 'Something Went Wrong!');
      setFromErrors(err.data, setErrors);
    }
  }, [isSuccess, isError]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" backdrop="static">
      {isLoading ? (
        <div className="overlay">
          <img src={loader} alt="Loading" height={100} width={300} />
        </div>
      ) : null}
      <ModalHeader toggle={toggle}>Progress Report Interview</ModalHeader>
      <Card>
        <CardBody>
          <div className="gap-2 w-100 ">
            <Form
              className="custom-form"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <Row>
                <Col>
                  <div className="mb-3">
                    <Label><u>Recent Seen Case(Cold)</u></Label>
                  </div>
                  <div className="row mb-3">
                    <div className="col-sm-3">
                      <Label>Point Of History</Label>
                      <InputField
                        type="text"
                        className="form-control"
                        placeholder="Point Of History"
                        {...getFieldProps('point_in_history')}
                      />
                    </div>
                    <div className="col-sm-2">
                      <Label>Evaluation</Label>
                      <InputField
                        type="select"
                        className="form-control"
                        placeholder="Evaluation"
                        options={evaluationOptions}
                        {...getFieldProps('point_in_history_assessment')}
                      />
                    </div>
                    <div className="col-sm-3">
                      <Label>Point Of Examination</Label>
                      <InputField
                        type="text"
                        className="form-control"
                        placeholder="Point Of Examination"
                        {...getFieldProps('point_in_examination')}
                      />
                    </div>
                    <div className="col-sm-2">
                      <Label>Evaluation</Label>
                      <InputField
                        type="select"
                        className="form-control"
                        placeholder="Evaluation"
                        options={evaluationOptions}
                        {...getFieldProps('point_in_examination_assessment')}
                      />
                    </div>
                    <div className="col-sm-2">
                      <Label>Comment</Label>
                      <InputField
                        type="text"
                        className="form-control"
                        placeholder="Comment"
                        options={evaluationOptions}
                        {...getFieldProps('recently_seen_case_comment')}
                      />
                    </div>

                  </div>
                  <div className="mb-3">
                    <Label><u>Emergency Managed</u></Label>
                  </div>
                  <div className="row mb-3">
                    <div className="col-sm-3">
                      <Label>Problem</Label>
                      <InputField
                        type="text"
                        className="form-control"
                        placeholder="Problem"
                        {...getFieldProps('problem')}
                      />
                    </div>
                    <div className="col-sm-2">
                      <Label>Evaluation</Label>
                      <InputField
                        type="select"
                        className="form-control"
                        placeholder="Evaluation"
                        options={evaluationOptions}
                        {...getFieldProps('problem_assessment')}
                      />
                    </div>
                    <div className="col-sm-3">
                      <Label>How Managed</Label>
                      <InputField
                        type="text"
                        className="form-control"
                        placeholder="How Managed"
                        {...getFieldProps('how_managed')}
                      />
                    </div>
                    <div className="col-sm-2">
                      <Label>Evaluation</Label>
                      <InputField
                        type="select"
                        className="form-control"
                        placeholder="Evaluation"
                        options={evaluationOptions}
                        {...getFieldProps('how_managed_assessment')}
                      />
                    </div>
                    <div className="col-sm-2">
                      <Label>Comment</Label>
                      <InputField
                        type="text"
                        className="form-control"
                        placeholder="Comment"
                        options={evaluationOptions}
                        {...getFieldProps('emergency_managed_comment')}
                      />
                    </div>

                  </div>
                  <div className="mb-3">
                    <Label><u>Procedure</u></Label>
                  </div>
                  <div className="row mb-3">
                    <div className="col-sm-3">
                      <Label>Why Done</Label>
                      <InputField
                        type="text"
                        className="form-control"
                        placeholder="Why Done"
                        {...getFieldProps('why_done')}
                      />
                    </div>
                    <div className="col-sm-2">
                      <Label>Evaluation</Label>
                      <InputField
                        type="select"
                        className="form-control"
                        placeholder="Evaluation"
                        options={evaluationOptions}
                        {...getFieldProps('why_done_assessment')}
                      />
                    </div>
                    <div className="col-sm-3">
                      <Label>How Done/any Problem</Label>
                      <InputField
                        type="text"
                        className="form-control"
                        placeholder="How Managed"
                        {...getFieldProps('how_done')}
                      />
                    </div>
                    <div className="col-sm-2">
                      <Label>Evaluation</Label>
                      <InputField
                        type="select"
                        className="form-control"
                        placeholder="Evaluation"
                        options={evaluationOptions}
                        {...getFieldProps('how_done_assessment')}
                      />
                    </div>
                    <div className="col-sm-2">
                      <Label>Comment</Label>
                      <InputField
                        type="text"
                        className="form-control"
                        placeholder="Comment"
                        options={evaluationOptions}
                        {...getFieldProps('procedure_comment')}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              <FormGroup className="mb-3 text-center">
                <Button type="reset" className="btn btn-secondary me-2" onClick={() => resetForm()}>
                  Reset
                </Button>

                <Button
                  type="submit"
                  className="btn btn-success me-2"

                >
                  Submit
                </Button>
              </FormGroup>
            </Form>
          </div>
        </CardBody>
      </Card>
    </Modal>
  );
};

export default ProgressReportInterview;
